import React from 'react'
import xss, { FilterXSS, whiteList } from 'xss'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import { wrapLastWordWithClass } from './wrapLastWordWithClass'
import { Link } from '../../types/Link.type'
import './style.module.scss'

export type RelatedInfoProps = {
  className?: string
  superheadline?: string
  relatedlinks?: Link[]
  analyticsName?: string
  testId?: string
}

const customXssFilter = new FilterXSS({
  whiteList: { ...whiteList, span: ['class'] }
})

export const RelatedInfo = (props: RelatedInfoProps) => {
  const { className, superheadline, relatedlinks, analyticsName, testId } =
    props
  const atb = new AnalyticsTagBuilder()
    .setDefaultName('RelatedInfo')
    .setAnalyticsName('relatedInfo-content-links-clicks')

  const relatedInfoLinks = relatedlinks
    ? Array.isArray(relatedlinks)
      ? relatedlinks
      : [relatedlinks]
    : []

  const visibleLinks = relatedInfoLinks.filter(link => {
    return link.url && !link.url.includes('/zzz__hidden__/')
  })

  if (visibleLinks.length === 0) {
    return null
  }

  return (
    <div
      className={`RelatedInfo u-bgColorStone u-sm-marginLeft0 u-md-marginLeft0 ${className}`}
      data-testid={testId ? `${testId}` : undefined}
    >
      <div
        className="RelatedInfo-content u-padding4gu u-padding4gu u-paddingBottom2gu"
        {...atb.dataAnalyticAttribute(analyticsName)}
      >
        <h1
          className="u-textPrimary u-textColorNeutral u-textBold u-textSizeMsrp2 u-paddingBottom4gu"
          data-testid={testId ? `${testId}-heading` : undefined}
        >
          {superheadline?.trim() || 'Related Information'}
        </h1>
        <ul>
          {visibleLinks.map((link, key) => {
            const wrappedName = wrapLastWordWithClass(
              link.name,
              'RelatedLinks--arrow'
            )
            return (
              <li
                key={key}
                data-testid={testId ? `${testId}-related-links` : undefined}
              >
                <a
                  href={xss(link.url)}
                  target={link.target}
                  data-analytics={link.analyticsName}
                  data-testid={testId ? `${testId}-link` : undefined}
                  dangerouslySetInnerHTML={{
                    __html: customXssFilter.process(wrappedName)
                  }}
                />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
